import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import Bulb from '../images/Bulb_black.svg'

import { specialTheme, widthXS } from '../theme'
import { useTranslation } from 'react-i18next'
import { CaseTypeType } from '../models'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    margin: specialTheme.layout.gridTypographyTextMargin,
    paddingLeft: 0,
    paddingRight: 0,
    border: `3px solid ${specialTheme.colors.gray.warmGray}`,
  },
  customizedButton: {
    color: 'gray',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    minWidth: '4rem'
  },
  paragraphText: {
    color: specialTheme.colors.dark,
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: 0,
    },
    fontWeight: 600,
    fontFamily: specialTheme.font.fontFSMe,
    letterSpacing: 0.24,
    paddingLeft: 0,
    paddingRight: '1.2rem',
    margin: '0 0 0.5rem 0',
  },
  defaultText: {
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: 0,
    },
    fontFamily: specialTheme.font.fontFSMe,
    letterSpacing: 0.24,
    paddingLeft: 0,
    paddingRight: '1.2rem',
    margin: '0 0 1rem 0',
  },
  text: {
    color: specialTheme.colors.dark,
    fontFamily: specialTheme.font.fontFSMe,
    fontSize: specialTheme.layout.gridTypographyTextFontSize,
    fontWeight: specialTheme.layout.gridTypographyTextFontWeight,
    [theme.breakpoints.down(widthXS)]: {
      fontSize: specialTheme.layout.gridTypographyTextFontSizeWidthXS,
    },
    letterSpacing: specialTheme.layout.gridTypographyTextLetterSpacing,
    margin: specialTheme.layout.gridTypographyTextMargin,
    paddingLeft: 0,
    paddingRight: '1.2rem',
  },
}))

export const InfoBox = (props: { caseType: CaseTypeType | null }) => {
  const { t } = useTranslation()
  const listLocale: string[] = t(`InfoBox.list.${props.caseType}`, {
    defaultValue: [] /* returned if not found */,
    returnObjects: true,
  })
  const classes = useStyles()
  return (
    <Stack className={classes.container} direction="row" sx={{ alignItems: 'start' }}>
      <Box className={classes.icon}>
        <img src={Bulb} alt="Bulb" style={{
          width: '100%', paddingTop: '80px',
          // paddingLeft: '1rem' 
        }} />
      </Box>
      <Stack >
        <Typography className={classes.text} variant="h3">
          {t('InfoBox.title')}
        </Typography>
        <div className={classes.defaultText}>
          <ul>
            {listLocale.map((stringItem, index) => (
              <li key={index}>{stringItem}</li>
            ))}
          </ul>
        </div>
        {(props.caseType === 'BA' || props.caseType === 'PL') && (
          <Typography className={classes.defaultText} variant="h5">
            {t('InfoBox.paragraph')}
          </Typography>
        )}
        <Typography className={classes.paragraphText}>
          {t('InfoBox.summary')}
        </Typography>
      </Stack>
    </Stack>
  )
}
